var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplaints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2067_1615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.387 283.194C206.552 283.194 173 243.445 173 191.992C173 140.539 206.546 100.79 250.387 100.79C294.223 100.79 327.775 140.539 327.775 191.992C327.775 243.445 294.223 283.194 250.387 283.194ZM250.387 111.12C213.319 111.12 183.158 147.4 183.158 191.992C183.158 236.583 213.319 272.864 250.387 272.864C287.456 272.864 317.617 236.583 317.617 191.992C317.617 147.4 287.456 111.12 250.387 111.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.115 180.907C303.697 180.907 303.28 180.901 302.857 180.882C289.047 180.372 272.948 171.513 262.721 159.538C255.567 168.782 245.352 174.73 232.708 176.907C210.59 180.758 185.295 172.148 177.602 164.577L186.148 157.756C189.853 161.407 210.903 170.16 230.652 166.751C242.91 164.642 251.745 158.253 256.911 147.771L262.04 137.376L267.727 147.466C274.519 159.522 290.814 170.092 303.311 170.558C308.869 170.708 312.82 169.022 315.342 165.227L325.52 170.064C320.857 177.087 313.293 180.907 304.115 180.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.997 161.6C344.997 156.323 340.497 152.04 334.952 152.04C329.407 152.04 324.906 156.323 324.906 161.6C324.906 163.875 324.906 231.025 324.906 233.3C324.906 238.577 329.407 242.86 334.952 242.86C340.497 242.86 344.997 238.577 344.997 233.3C344.997 231.025 344.997 163.875 344.997 161.6Z",
    stroke: "white",
    strokeWidth: 9.15163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.635 290.66C270.18 290.66 274.68 286.377 274.68 281.1C274.68 275.823 270.18 271.54 264.635 271.54C262.244 271.54 241.913 271.54 239.522 271.54C233.977 271.54 229.477 275.823 229.477 281.1C229.477 286.377 233.977 290.66 239.522 290.66C241.913 290.66 262.244 290.66 264.635 290.66Z",
    stroke: "white",
    strokeWidth: 9.15163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.18 156.821C164.18 111.941 202.407 75.5605 249.565 75.5605C296.723 75.5605 334.95 111.941 334.95 156.821",
    stroke: "white",
    strokeWidth: 9.15163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 161.6C358.873 161.6 370.113 177.646 370.113 197.45C370.113 217.244 358.873 233.3 345 233.3",
    stroke: "white",
    strokeWidth: 9.15163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.133 161.6C154.133 156.323 158.633 152.04 164.178 152.04C169.723 152.04 174.223 156.323 174.223 161.6C174.223 163.875 174.223 231.025 174.223 233.3C174.223 238.577 169.723 242.86 164.178 242.86C158.633 242.86 154.133 238.577 154.133 233.3C154.133 231.025 154.133 163.875 154.133 161.6Z",
    stroke: "white",
    strokeWidth: 9.15163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.137 161.6C140.269 161.6 129.023 177.646 129.023 197.45C129.023 217.244 140.269 233.3 154.137 233.3",
    stroke: "white",
    strokeWidth: 9.15163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.952 242.859C334.952 266.759 319.884 281.099 294.77 281.099H274.68",
    stroke: "white",
    strokeWidth: 9.15163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 380C106 380 110.552 354.734 119.616 342.588C127.162 332.474 133.957 329.489 144.211 322.91C158.69 313.62 183.96 305.175 183.96 305.175M183.96 305.175L202.626 294L228.32 311.734L250.061 327.525M183.96 305.175L202.626 327.525L225.465 354.248L238.641 339.429M250.061 327.525L275.535 353.034L319.676 308.333M250.061 327.525L302.327 294L319.676 308.333M319.676 308.333C319.676 308.333 335.354 312.838 345.15 316.593C354.931 320.343 361.273 320.945 369.745 327.525C377.343 333.426 381.078 338.008 385.996 346.717C391.715 356.845 395 375.627 395 375.627",
    stroke: "white",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.5,
    cy: 372,
    rx: 7.5,
    ry: 8,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2067_1615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaints);
export default __webpack_public_path__ + "static/media/complaints.918e9adef3e955ad072cfb52f9d93411.svg";
export { ForwardRef as ReactComponent };